/* NORPEX JS v9.0 */
(function(){
'use strict';
const $=s=>document.querySelector(s),$$=s=>document.querySelectorAll(s);
 
/* ===== HEADER SCROLL ===== */
const hdr=$('#site-header');
if(hdr){window.addEventListener('scroll',()=>hdr.classList.toggle('scrolled',scrollY>10),{passive:true});}
 
/* ===== MOBILE NAV ===== */
const burger=$('#hamburger'),mob=$('#mobile-nav'),overlay=$('#norpex-overlay');
let _scrollY=0;
 
function openNav(){
  if(!mob)return;
  _scrollY=window.scrollY||window.pageYOffset;
  mob.classList.add('is-open');
  burger&&burger.classList.add('open');
  overlay&&overlay.classList.add('is-active');
  document.body.style.position='fixed';
  document.body.style.top='-'+_scrollY+'px';
  document.body.style.left='0';
  document.body.style.right='0';
  mob.scrollTop=0;
}
 
function closeNav(){
  if(!mob)return;
  mob.classList.remove('is-open');
  burger&&burger.classList.remove('open');
  document.body.style.position='';
  document.body.style.top='';
  document.body.style.left='';
  document.body.style.right='';
  window.scrollTo(0,_scrollY);
  if(!cartDrawer||!cartDrawer.classList.contains('is-open')){
    overlay&&overlay.classList.remove('is-active');
  }
}
 
if(burger){
  ['click','touchend'].forEach(ev=>burger.addEventListener(ev,function(e){
    e.preventDefault();e.stopPropagation();
    mob.classList.contains('is-open')?closeNav():openNav();
  },{passive:false}));
}
 
/* Nav linkleri tıklanınca kapat */
mob&&$$('#mobile-nav a').forEach(a=>a.addEventListener('click',closeNav));
 
/* Back butonu */
const backBtn=$('#mobile-back-btn');
if(backBtn)backBtn.addEventListener('click',function(){closeNav();});
 
/* ===== CART ===== */
const cartDrawer=$('#cart-drawer'),cartBody=$('#cart-body'),cartClose=$('#cart-close'),cartFooter=$('#cart-footer');
 
function openCart(){
  if(cartDrawer)cartDrawer.classList.add('is-open');
  if(overlay)overlay.classList.add('is-active');
  document.body.style.overflow='hidden';
  fetchCart();
}
 
function closeCart(){
  if(cartDrawer)cartDrawer.classList.remove('is-open');
  if(!mob||!mob.classList.contains('is-open')){
    if(overlay)overlay.classList.remove('is-active');
    document.body.style.overflow='';
    document.body.style.position='';
    document.body.style.top='';
    document.body.style.left='';
    document.body.style.right='';
  }
}
 
if(cartClose){
  cartClose.addEventListener('click',function(e){e.stopPropagation();closeCart();});
  cartClose.addEventListener('touchend',function(e){e.preventDefault();e.stopPropagation();closeCart();},{passive:false});
}
 
$$('[data-cart-trigger]').forEach(b=>b.addEventListener('click',openCart));
 
if(overlay){
  overlay.addEventListener('click',function(e){
    if(cartDrawer&&cartDrawer.contains(e.target))return;
    closeCart();
    closeNav();
  });
}
 
function fmt(c){return '$'+(c/100).toFixed(2);}
 
function fetchCart(){
  fetch('/cart.js').then(r=>r.json()).then(renderCart).catch(console.error);
}
 
function attachFooterBtns(){
  const cont=$('#cart-continue');
  if(cont){
    cont.addEventListener('click',function(e){e.stopPropagation();closeCart();});
    cont.addEventListener('touchend',function(e){e.preventDefault();e.stopPropagation();closeCart();},{passive:false});
  }
}
 
function renderCart(cart){
  $$('.cart-count').forEach(el=>{
    el.textContent=cart.item_count;
    el.style.display=cart.item_count>0?'flex':'none';
  });
  const sub=$('#cart-subtotal-price');
  if(sub)sub.textContent=fmt(cart.total_price);
  if(cartFooter)cartFooter.style.display=cart.item_count>0?'block':'none';
  if(!cartBody)return;
  if(cart.item_count===0){
    cartBody.innerHTML='<div class="cart-empty"><p class="cart-empty-title">Your cart is empty</p><p class="cart-empty-text">Add something to get started.</p><a href="/collections/all" class="btn btn-outline">Shop Now</a></div>';
    attachFooterBtns();
    return;
  }
  cartBody.innerHTML=cart.items.map(item=>`
    <div class="cart-item" data-key="${item.key}">
      <a href="${item.url}" class="cart-item-img">
        ${item.image?`<img src="${item.image.replace('.jpg','_160x.jpg')}" alt="${item.title}" loading="lazy">`:''}
      </a>
      <div class="cart-item-info">
        <div class="cart-item-title">${item.product_title}</div>
        ${item.variant_title&&item.variant_title!=='Default Title'?`<div class="cart-item-variant">${item.variant_title}</div>`:''}
        <div class="cart-qty">
          <button class="cart-qty-btn" data-action="dec" data-key="${item.key}" data-qty="${item.quantity}" type="button">−</button>
          <span class="cart-qty-num">${item.quantity}</span>
          <button class="cart-qty-btn" data-action="inc" data-key="${item.key}" data-qty="${item.quantity}" type="button">+</button>
        </div>
        <div class="cart-item-price">${fmt(item.final_line_price)}</div>
        <button class="cart-item-remove" data-key="${item.key}" data-qty="0" type="button">Remove</button>
      </div>
    </div>`).join('');
  cartBody.querySelectorAll('.cart-qty-btn,.cart-item-remove').forEach(btn=>{
    btn.addEventListener('click',function(e){
      e.stopPropagation();
      const key=this.dataset.key;
      const qty=this.dataset.action==='inc'?+this.dataset.qty+1:this.dataset.action==='dec'?Math.max(0,+this.dataset.qty-1):0;
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
        .then(r=>r.json()).then(renderCart).catch(console.error);
    });
  });
  attachFooterBtns();
}
 
attachFooterBtns();
 
/* ===== ADD TO CART ===== */
document.addEventListener('submit',function(e){
  const form=e.target.closest('[data-product-form]');
  if(!form)return;
  e.preventDefault();
  const btn=form.querySelector('.add-to-cart'),idInput=form.querySelector('[name="id"]');
  if(!idInput)return;
  const orig=btn?btn.textContent:'';
  if(btn){btn.disabled=true;btn.textContent='Adding...';}
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:idInput.value,quantity:1})})
    .then(r=>r.json())
    .then(()=>{if(btn){btn.disabled=false;btn.textContent=orig;}openCart();})
    .catch(err=>{console.error(err);if(btn){btn.disabled=false;btn.textContent=orig;}});
});
 
/* ===== INLINE SEARCH ===== */
const searchInput=$('#header-search-input'),searchDropdown=$('#search-dropdown');
const categories=[
  {name:'Women — Hoodies',url:'/collections/women-hoodies'},
  {name:'Women — T-Shirts',url:'/collections/women-tshirts'},
  {name:'Women — Dresses',url:'/collections/women-dresses'},
  {name:'Men — Hoodies',url:'/collections/men-hoodies'},
  {name:'Men — T-Shirts',url:'/collections/men-tshirts'},
  {name:'Kids — Hoodies',url:'/collections/kids-hoodies'},
  {name:'Kids — T-Shirts',url:'/collections/kids-tshirts'},
  {name:'Unisex — Hoodies',url:'/collections/unisex-hoodies'},
  {name:'Unisex — T-Shirts',url:'/collections/unisex-tshirts'},
  {name:'Accessories',url:'/collections/accessories'},
];
let searchTimer;
if(searchInput&&searchDropdown){
  searchInput.addEventListener('input',function(){
    clearTimeout(searchTimer);
    const q=this.value.trim();
    if(q.length<2){searchDropdown.classList.remove('active');return;}
    searchTimer=setTimeout(()=>runSearch(q),300);
  });
  searchInput.addEventListener('keydown',function(e){
    if(e.key==='Enter'){window.location='/search?q='+encodeURIComponent(this.value);}
    if(e.key==='Escape'){searchDropdown.classList.remove('active');this.blur();}
  });
  document.addEventListener('click',function(e){
    if(!e.target.closest('.header-search-wrap')&&!e.target.closest('#search-dropdown'))searchDropdown.classList.remove('active');
  });
}
function runSearch(q){
  const ql=q.toLowerCase();
  const matchCats=categories.filter(c=>c.name.toLowerCase().includes(ql));
  fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6')
    .then(r=>r.json()).then(data=>{
      const products=(data.resources&&data.resources.results&&data.resources.results.products)||[];
      renderSearchDropdown(matchCats,products,q);
    }).catch(()=>renderSearchDropdown(matchCats,[],q));
}
function renderSearchDropdown(cats,products,q){
  if(!searchDropdown)return;
  let html='<div class="search-dropdown-inner">';
  if(cats.length){
    html+='<p class="search-cats-title">Categories</p><div class="search-cats">';
    html+=cats.slice(0,5).map(c=>`<a href="${c.url}" class="search-cat">${c.name}</a>`).join('');
    html+='</div>';
  }
  if(products.length){
    html+='<p class="search-products-title">Products</p><div class="search-results-grid">';
    html+=products.map(p=>`
      <a href="${p.url}" class="search-result-item">
        <div class="search-result-img">${p.featured_image?`<img src="${p.featured_image.url.replace('.jpg','_280x.jpg')}" alt="${p.title}" loading="lazy">`:''}
        </div>
        <div class="search-result-title">${p.title}</div>
        <div class="search-result-price">${p.price?'$'+parseFloat(p.price).toFixed(2):''}</div>
      </a>`).join('');
    html+='</div>';
  }
  if(!cats.length&&!products.length){
    html+=`<p style="color:rgba(242,238,230,.4);font-size:.82rem;">No results for "${q}"</p>`;
  }
  html+='</div>';
  searchDropdown.innerHTML=html;
  searchDropdown.classList.add('active');
}
 
/* ===== CAROUSEL ===== */
$$('.carousel-section').forEach(section=>{
  const track=section.querySelector('.carousel-track');
  if(!track)return;
  const prevBtn=section.querySelector('.carousel-prev');
  const nextBtn=section.querySelector('.carousel-next');
  let idx=0;
  function getVisible(){return window.innerWidth<749?2:window.innerWidth<1024?3:5;}
  function getSlides(){return track.querySelectorAll('.carousel-slide');}
  function getMax(){return Math.max(0,getSlides().length-getVisible());}
  function go(n){
    idx=Math.max(0,Math.min(n,getMax()));
    const slideW=getSlides()[0]?.offsetWidth||0;
    track.style.transform=`translateX(-${idx*(slideW+2)}px)`;
    if(prevBtn)prevBtn.style.opacity=idx===0?'.35':'1';
    if(nextBtn)nextBtn.style.opacity=idx>=getMax()?'.35':'1';
  }
  prevBtn&&prevBtn.addEventListener('click',()=>go(idx-1));
  nextBtn&&nextBtn.addEventListener('click',()=>go(idx+1));
  let autoTimer=setInterval(()=>{go(idx>=getMax()?0:idx+1);},4000);
  section.addEventListener('mouseenter',()=>clearInterval(autoTimer));
  section.addEventListener('mouseleave',()=>{autoTimer=setInterval(()=>{go(idx>=getMax()?0:idx+1);},4000);});
  let sx=0;
  track.addEventListener('touchstart',e=>{sx=e.touches[0].clientX;},{passive:true});
  track.addEventListener('touchend',e=>{const dx=sx-e.changedTouches[0].clientX;if(Math.abs(dx)>40)go(dx>0?idx+1:idx-1);},{passive:true});
  go(0);
});
 
/* ===== PRODUCT GALLERY ===== */
$$('.product-thumb').forEach(thumb=>{
  thumb.addEventListener('click',()=>{
    $$('.product-thumb').forEach(t=>t.classList.remove('active'));
    thumb.classList.add('active');
    const main=$('#main-product-image');
    if(main&&thumb.dataset.src)main.src=thumb.dataset.src;
  });
});
 
/* ===== SCROLL ANIMATIONS ===== */
if('IntersectionObserver' in window){
  const io=new IntersectionObserver(entries=>{
    entries.forEach(e=>{if(e.isIntersecting){e.target.style.opacity='1';e.target.style.transform='translateY(0)';io.unobserve(e.target);}});
  },{threshold:.08,rootMargin:'0px 0px -30px 0px'});
  $$('.product-card,.manifesto,.newsletter,.cat-card').forEach(el=>{
    el.style.opacity='0';el.style.transform='translateY(16px)';el.style.transition='opacity .55s ease,transform .55s ease';io.observe(el);
  });
}
 
/* ===== iOS FIX ===== */
if(/iPhone|iPad/.test(navigator.userAgent)){
  $$('input,select,textarea').forEach(el=>{if(parseFloat(getComputedStyle(el).fontSize)<16)el.style.fontSize='16px';});
}
 
/* ===== MOBILE CART SWIPE ===== */
if(cartDrawer&&window.innerWidth<750){
  let sy=0;
  cartDrawer.addEventListener('touchstart',e=>{sy=e.touches[0].clientY;},{passive:true});
  cartDrawer.addEventListener('touchmove',e=>{
    const dy=e.touches[0].clientY-sy;
    if(dy>0&&e.target!==cartClose){
      cartDrawer.style.transform=`translateY(${dy}px)`;
      cartDrawer.style.transition='none';
    }
  },{passive:true});
  cartDrawer.addEventListener('touchend',e=>{
    cartDrawer.style.transition='';
    const dy=e.changedTouches[0].clientY-sy;
    if(dy>100){closeCart();}else{cartDrawer.style.transform='';}
  },{passive:true});
}
 
/* ===== NEWSLETTER ===== */
const nlForm=$('.newsletter-form');
if(nlForm)nlForm.addEventListener('submit',e=>{e.preventDefault();nlForm.innerHTML='<p style="color:var(--color-cream);font-size:.85rem;letter-spacing:.1em;">Thank you — you\'re in.</p>';});
 
})();